export default {
	localSession: "_LOCAL_SESSION_SERVICO_",
	localConfig: "_LOCAL_SEVICE_SISTEMA_CONFIG_",
	localBaseURL: "_LOCAL_BASE_URL",
}



// WEBPACK FOOTER //
// ./src/config/local-storage.js